<label [for]="name" class="flex justify-start items-center cursor-pointer">
  <div
    class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2">
    <input 
      type="checkbox"
      [id]="name" 
      [name]="name" 
      [disabled]="disabled"
      [(ngModel)]="value" 
      (blur)="blur.emit()" 
      (focus)="focus.emit()"
      class="opacity-0 absolute"
    >
    <svg class="fill-current hidden w-4 h-4 text-purple-600 pointer-events-none" viewBox="0 0 20 20">
      <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
    </svg>
  </div>
  <div *ngIf="showLabel" class="text-sm text-gray-600 tracking-wide">{{ name }}</div>
</label>
<div class="h-4 pt-1">
  <app-input-errors *ngIf="hasError" [errors]="ngControl?.control?.errors!"></app-input-errors>
</div>